import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=7bda0512&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=ts&"
export * from "./attribute.vue?vue&type=script&lang=ts&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=7bda0512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda0512",
  null
  
)

export default component.exports